var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-alert',{attrs:{"show":_vm.show,"dismissible":""}},[_vm._v("\n  You should be using Google Chrome.\n  "),_c('a',{attrs:{"href":_vm.href}},[_vm._v("\n    Learn More\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }